var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83386 2.80889C9.48183 2.17423 10.5183 2.17423 11.1663 2.80889L11.9769 3.60279C12.2841 3.90371 12.6957 4.07422 13.1258 4.07869L14.2603 4.09046C15.1672 4.09987 15.9002 4.8328 15.9096 5.73974L15.9214 6.87426C15.9258 7.30429 16.0963 7.71595 16.3973 8.02319L17.1912 8.83374C17.8258 9.4817 17.8258 10.5182 17.1912 11.1662L16.3973 11.9767C16.0963 12.284 15.9258 12.6956 15.9214 13.1257L15.9096 14.2602C15.9002 15.1671 15.1672 15.9 14.2603 15.9095L13.1258 15.9212C12.6957 15.9257 12.2841 16.0962 11.9769 16.3971L11.1663 17.191C10.5183 17.8257 9.48183 17.8257 8.83386 17.191L8.02331 16.3971C7.71608 16.0962 7.30442 15.9257 6.87439 15.9212L5.73987 15.9095C4.83292 15.9 4.1 15.1671 4.09058 14.2602L4.07881 13.1257C4.07435 12.6956 3.90383 12.284 3.60291 11.9767L2.80901 11.1662C2.17436 10.5182 2.17436 9.4817 2.80901 8.83374L3.60291 8.02319C3.90383 7.71595 4.07435 7.30429 4.07881 6.87427L4.09058 5.73974C4.1 4.8328 4.83292 4.09987 5.73986 4.09046L6.87439 4.07869C7.30442 4.07422 7.71608 3.90371 8.02331 3.60279L8.83386 2.80889Z",
    stroke: "#4B5563",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 2.5,
    stroke: "#4B5563",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.6f8fc489381319512df720acb487800a.svg";
export { ForwardRef as ReactComponent };